import React, { useContext } from 'react';
import AppContext from '../context/Context';
import SupportRoutes from '../routes/SupportRoutes';

const SupportLayout = () => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <SupportRoutes />
            </div>
}

export default SupportLayout;